import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UrlPipe } from '@spartacus/core';
import { ColumnConfig } from 'material-dynamic-table';
import { TooltipTextComponent } from '../../../tooltip-text/tooltip-text.component';

@Component({
  selector: 'app-saved-carts-list-name-cell',
  templateUrl: './saved-carts-list-name-cell.component.html',
  styleUrls: ['./saved-carts-list-name-cell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLink, TooltipTextComponent, UrlPipe],
})
export class SavedCartsListNameCellComponent implements OnInit {
  @Input() column: ColumnConfig;
  @Input() row: any;

  constructor() {}

  ngOnInit() {}
}
